import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {ApiBaseService} from "@portal/api/api-base-service";
import {ForgotPasswordRequest} from "@portal/api/requests/auth/forgot-password-request";
import {map, Observable} from "rxjs";
import {Success} from "@portal/api/responses/api-response";
import {AuthToken} from "@portal/api/responses/Auth/auth-token";
import {ResetPasswordRequest} from "@portal/api/requests/auth/reset-password-request";
import {LoginResponse} from "@portal/api/responses/Auth/login-response";
import {RegisterResponse} from "@portal/api/responses/Auth/register-response";
import {LoginRequest} from "@portal/api/requests/auth/login-request";
import {EmailConfirmationRequest} from "@portal/api/requests/auth/email-confirmation-request";
import {RegisterNewAccountRequest} from "@portal/api/requests/auth/register-new-account-request";


@Injectable({
    providedIn: 'root'
})
export class AccountService extends ApiBaseService {
    controller = 'v1/Account';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(request: ForgotPasswordRequest): Observable<void> {
        return this.post<void, ForgotPasswordRequest>(request, this.controller + `/ForgotPassword`);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(request: ResetPasswordRequest): Observable<void> {
        return this.post<void, ResetPasswordRequest>(request, this.controller + `/ResetPassword`);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<LoginResponse> {
        return this.post<Success<LoginResponse>, LoginRequest>(credentials, this.controller + `/Login`).pipe(
            map((response) => response.data)
        );
    }

    confirmEmail(request: EmailConfirmationRequest): Observable<boolean> {
        return this.post<void, EmailConfirmationRequest>(request, this.controller + `/ConfirmEmail`).pipe(
            map(() => true)
        );
    }

    resendConfirmaionEmail(email: string): Observable<boolean> {
        return this.post<void, string>(email, this.controller + `/ResendEmailToken`).pipe(
            map(() => true)
        );
    }

    getNewAccessToken(refreshToken: string): Observable<Success<AuthToken>> {
        return this.post<Success<AuthToken>, null>(null, this.controller + '/RefreshAccessToken?refreshToken=' + refreshToken);
    }

    /**
     * Sign up
     *
     * @param request
     */
    signUp(request: RegisterNewAccountRequest): Observable<Success<RegisterResponse>> {
        return this.post<Success<RegisterResponse>, RegisterNewAccountRequest>(request, this.controller + '/RegisterNewAccount');
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

}
